'use client'

import { Suspense, useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

function GoogleAnalyticsPageView({ measurementId }: { measurementId: string }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const trackPageView = () => {
      window.gtag?.('config', measurementId, {
        page_path: `${pathname}${searchParams.size ? `?${searchParams.toString()}` : ''}`,
      })
    }

    trackPageView()
    window.addEventListener('googleAnalyticsReady', trackPageView)
    return () => window.removeEventListener('googleAnalyticsReady', trackPageView)
  }, [measurementId, pathname, searchParams])

  return null
}

export function GoogleAnalytics({ measurementId }: { measurementId: string }) {
  return (
    <Suspense fallback={null}>
      <GoogleAnalyticsPageView measurementId={measurementId} />
    </Suspense>
  )
}